import { TModoGestaoAtendimento } from "../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";
import { ListarAtendimentosRequest } from "../../../Interfaces/Cobranca/GestaoAtendimento/GestaoAtendimentoInterface";
import {
    ExportarExcelAtendimentosCobrancaService,
    ListarAtendimentosService,
} from "../../../Services/Cobranca/GestaoAtendimento/GestaoAtendimentoService";
import { ValidationErr } from "../../../Validations/ValidationError";
import { Controller } from "../../Controller";

export async function ListarAtendimentosController(
    data: ListarAtendimentosRequest,
    SEG_ATENDIMENTOS: TModoGestaoAtendimento
) {
    // garante que o dia todo será contado na busca
    data.DT_PERIODO_INICIO =
        data.DT_PERIODO_INICIO?.split("T")[0]?.concat("T00:00");
    data.DT_PERIODO_FIM = data.DT_PERIODO_FIM?.split("T")[0]?.concat("T23:59");

    const response = await ListarAtendimentosService(data, SEG_ATENDIMENTOS)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });

    return response;
}

export async function ExportarExcelAtendimentosCobrancaController(
    requestBody: ListarAtendimentosRequest,
    SEG_ATENDIMENTOS: TModoGestaoAtendimento
) {
    return Controller(
        ExportarExcelAtendimentosCobrancaService(requestBody, SEG_ATENDIMENTOS)
    );
}

export async function ListarAtendimentosCobrancaTransferirController(
    data: ListarAtendimentosRequest,
    SEG_ATENDIMENTOS: TModoGestaoAtendimento
) {
    return Controller(ListarAtendimentosService(data, SEG_ATENDIMENTOS, true));
}
